import { useEffect } from "react";
import { useThemeStore } from "../store";

declare const Office: any;

export default function useOfficeTheme() {
  const { setDarkMode, setThemeId } = useThemeStore();
  useEffect(() => {
    function getOutlookTheme(): string {
      try {
        if (typeof Office !== "undefined" && Office.context?.officeTheme) {
          const office: any = Office.context.officeTheme;
          console.log("office >>>", office);
          return office?.controlBackgroundColor || "#000003";
        }
      } catch {}
      return "#000003";
    }

    function isHexDark(hex: string): boolean {
      const c = hex.replace("#", "");
      if (c.length !== 6) return false;
      const r = parseInt(c.slice(0, 2), 16);
      const g = parseInt(c.slice(2, 4), 16);
      const b = parseInt(c.slice(4, 6), 16);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance < 0.5;
    }

    function applyTheme() {
      const themeId = getOutlookTheme();

      const isDark = themeId.toString().toLowerCase().includes("dark")
        ? true
        : themeId.startsWith("#")
        ? isHexDark(themeId)
        : false;

      const root = document.documentElement;
      if (isDark) {
        root.classList.add("dark");
      } else {
        root.classList.remove("dark");
      }

      setThemeId(themeId);
      setDarkMode(isDark);
    }

    if (typeof Office !== "undefined") {
      Office.onReady?.(() => {
        applyTheme();

        const officeTheme = Office.context?.officeTheme;
        if (officeTheme?.addHandlerAsync) {
          try {
            officeTheme.addHandlerAsync(Office.EventType.OfficeThemeChanged, () => {
              applyTheme();
            });
          } catch (error) {
            console.warn("Failed to attach OfficeThemeChanged handler", error);
          }
        }
      });
    } else {
      const mq = window.matchMedia("(prefers-color-scheme: dark)");
      applyTheme();
      const handler = () => applyTheme();
      mq.addEventListener("change", handler);
      return () => mq.removeEventListener("change", handler);
    }
    return undefined;
  }, []);
}
